import React from "react";
import { logoutUser } from "../../services/authService";
import logoDark from "../../assets/images/sord_logo_transparent.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./common.module.scss";

export const Navigation = (props) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("accessToken");

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      id="menu"
      className={"navbar navbar-default navbar-fixed-top"}
      style={{
        background: scrolled
          ? "linear-gradient(to right, #1e2a3c 0%, #1e2a3c 100%)"
          : "transparent",
        borderColor: scrolled ? "rgba(231, 231, 231, 0)" : "transparent",
        boxShadow: scrolled ? "0 0 10px rgba(0, 0, 0, 0.15)" : "none",
      }}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <img
            src={logoDark}
            alt="Logo"
            height={45}
            style={{ borderRadius: "6px" }}
            onClick={() => navigate("/")}
          />
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {token && (
              <li>
                <a href="/home" className="page-scroll">
                  Go to Dashboard
                </a>
              </li>
            )}
            <li>
              <a href="/about-us" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="/pricing" className="page-scroll">
                Pricing
              </a>
            </li>
            {!token ? (
              <li>
                <a href="/login" className={classes.loginBtn}>
                  Login
                </a>
              </li>
            ) : (
              <li>
                <a href="/" className={classes.loginBtn} onClick={logoutUser}>
                  logout
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
